export default "__VITE_ASSET__BjL8TwV7__"